(ns fablo-offers.app.root-view
  (:require
   [fablo-offers.app.routes :as routes]
   [reitit.frontend.easy :as rfe]
   [lambdaisland.glogi :as log]
   [fablo-offers.common.components.language-selector :as language-selector]
   [fablo-offers.app.components.app :as app]
   [fablo-offers.app.components.offer]
   [fablo-offers.app.components.form]
   [rumext.alpha :as mf]
   [fablo-offers.common.state :as s]
   ["jotai" :as j]
   ["jotai/query" :as jq]
   ["@chakra-ui/react" :as ch]
   ["react" :as react]
   ["react-query" :as rq]
   ["react-query/devtools" :as rqd]))

(mf/defc router-view []
  (let [state (s/use-atom app/route-state)]
    (mf/with-effect
      []
      
      (js/window.addEventListener
       "popstate"
       (fn [e]
         (vreset! app/next-transition :back)))

      (rfe/start!
       routes/router
       (fn [m _history]
         ;(js/console.log "router-view" m _history @app/next-transition)
         (let [transition (or @app/next-transition :forward)]
           (vreset! app/next-transition nil)
           (cond
             (:app/component (:data m)) (reset! state (:data m))
             m
             (reset!
              state
              (merge {:screen (or (get-in m [:data :data-source])
                                  (get-in m [:data :name]))
                      :transition transition}
                     (get-in m [:parameters :path])
                     (get-in m [:parameters :query]))))))
       {:use-fragment false}))
    [:& app/screen]))

(mf/defc jotai-query-init []
  (let [jqc (s/use-atom jq/queryClientAtom)]
    (mf/with-effect [] (reset! jqc s/query-client))))

(mf/defc root-view []
  [:> rq/QueryClientProvider {:client s/query-client}
   [:& jotai-query-init {}]
   [:> rqd/ReactQueryDevtools {}]
   [:> react/Suspense {}
    [:div#page-wrapper {}
     [:& router-view]]]])
